import { render, staticRenderFns } from "./SupplierStocksBlockedComponent.vue?vue&type=template&id=6233c6a1&"
import script from "./SupplierStocksBlockedComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierStocksBlockedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports